import React from 'react'

import './styles.scss'

const Loading = ({ loading }) => {
  const isLoading = loading === undefined ? true : loading;
  return isLoading ? (
    <div className="loading">
      <div className="loading-center">
        <div className="loading-center-wrapper">
          <img className="loading-logo" src={require('../../assets/images/loading_logo.svg')} alt=""/>
          <img className="loading-logo-center" src={require('../../assets/images/loading_logo_center.svg')} alt=""/>
        </div>
      </div>
    </div>
  ) : null
};

export default Loading;
